import { Component, OnInit, ViewChild, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { orderType } from '@app/_models';
import { breakpointPixels, FadvModalComponent } from '@fa-switch-sharedservices/ng-elements';

@Component({
  selector: 'app-order-modal',
  templateUrl: './order-modal.component.html',
  styleUrls: ['./order-modal.component.css']
})
export class OrderModalComponent implements OnInit {

  orderType = orderType;
  currentOrderType: string;
  backButtonAlignment: string;
  nextButtonAlignment: string;
  innerWidth: number = window.innerWidth;
  buttonTextSize: string;
  
  @Output() startOrder: EventEmitter<string> = new EventEmitter();
  @Output() hideNewOrderButton: EventEmitter<string> = new EventEmitter();
  @ViewChild('orderModal') orderModal!: FadvModalComponent;

  constructor() { }

  @HostListener('window:resize', ['$event'])
  onResize(event){
      this.innerWidth = window.innerWidth;
      this.handleViewChange();
  }

  handleViewChange(): void{
    if(this.innerWidth <= breakpointPixels.md)
    {
     this.backButtonAlignment = "center";
     this.nextButtonAlignment = "center";
     this.buttonTextSize = "paragraph-medium";
    }
    else
    {
      this.backButtonAlignment = "right";
      this.nextButtonAlignment = "left";
      this.buttonTextSize = "paragraph-large";
    }
    if(this.innerWidth <= breakpointPixels.sm)
    {
      this.buttonTextSize = "paragraph-x-small";
    }
  }

  ngAfterViewInit(): void{
    this.handleViewChange();
  }

  hide() {
    this.orderModal.hide();
    this.hideNewOrderButton.emit("flex");
  }

  show() {
    this.orderModal.show();
    this.hideNewOrderButton.emit("none");
  }

  onClick() {
    this.startOrder.emit(orderType[this.currentOrderType]);
  }

  selectOrderType(order: string): void{
    if(order == 'invite'){
      this.currentOrderType = order;
    }

    if(order == 'online'){
      this.currentOrderType = order;
    }
  }


  ngOnInit(): void {

  }
}
